import React, { useEffect, useState } from "react"
import store from "src/store"
import moment from "moment"
import AnalyticsFilter from "./analytics-filter"
import AnalyticsHeader from "./analytics-header"
import AnalyticsTable from "./analytics-table"
import Progress from "./progress"
import useIsLoggedIn from "src/utils/use-is-logged-in"
import Disclaimer from "./disclaimer"

export default function Analytics() {
  const { isLoggedIn } = useIsLoggedIn()

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (store.isAdmin) {
      store.clearAnalyticsFilter()
      getAnalytics()
    }
  }, [store.isAdmin]);

  const getAnalytics = async () => {
    setLoading(true)
    await store.fetchtAnalytics({
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    })
    setLoading(false)
  }

  store.useRerenderIfChange(() => [
    store.analytics,
    store.analyticsFilter,
    store.isAdmin,
  ])

  const getAnalyticsError = () => {
    if (store.analytics === undefined || !Array.isArray(store.analytics)) {
      return "Unable to fetch analytics"
    } else {
      return "No analytics found"
    }
  }

  return (
    <>
      {isLoggedIn && (store.isAdmin || store.hasEngagementManagerAccess) ? (
        <div
          css={`
            padding: 35px;
            background: #f6f6fa;
            min-height: 100vh;
          `}
        >
          <div>
            <AnalyticsHeader />
            <Disclaimer />
          </div>
          <hr
            css={`
              margin-top: 15px;
              border: 1px solid #eaeaf2;
            `}
          />
          <div>
            <AnalyticsFilter />
          </div>
          <div
            css={`
              margin-top: 25px;
              margin-bottom: 100px;
            `}
          >
            {loading && <Progress />}
            {!loading && (
              <div>
                {store.analytics.length ? (
                  <AnalyticsTable />
                ) : (
                  getAnalyticsError()
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          css={`
            padding: 35px;
            background: #f6f6fa;
            min-height: 100vh;
          `}
        >
          <h2 css="color: red;">Access denied!</h2>
        </div>
      )}
    </>
  )
}
